export default "<p>admin-survey-lis-update works!</p>\n"